import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/release/log',
    name: 'RELEASE_LOG',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], isLoading, exec];
});
